import React from 'react'
import { VuiButton } from '@topkamera/viso-ui'
import { defaultNotifier } from 'functions/notificationHandler'
import './notifications.scss'

const normalizeNavigateTarget = (resourceUrl) => {
  if (!resourceUrl || typeof resourceUrl !== 'string') return null
  try {
    const parsed = new URL(resourceUrl, window.location.origin)
    return `${parsed.pathname}${parsed.search}${parsed.hash}`
  } catch (e) {
    return resourceUrl
  }
}

export const handleNotification = ({
  message, payload, navigate
}) => {
  const { resourceUrl, actorName } = payload || {}
  const generateId = crypto.randomUUID()

  let pointerDown = false
  let startX = 0
  let startY = 0
  let didDrag = false

  return defaultNotifier(generateId, false,
    <div
      className='viso-snackbar-content'
      onPointerDown={(e) => {
        pointerDown = true
        didDrag = false
        startX = e.clientX
        startY = e.clientY
      }}
      onPointerMove={(e) => {
        if (!pointerDown) return
        const dx = Math.abs(e.clientX - startX)
        const dy = Math.abs(e.clientY - startY)
        if (dx > 6 || dy > 6) didDrag = true
      }}
      onPointerUp={() => {
        pointerDown = false
      }}
      onPointerCancel={() => {
        pointerDown = false
      }}
      onClick={() => {
        if (didDrag) {
          didDrag = false
          return
        }
        const target = normalizeNavigateTarget(resourceUrl)
        if (!target) return
        navigate(target)
      }}
    >
      {resourceUrl ? <span className='viso-snackbar-content-link'>{message}</span> : message} by {actorName}
    </div>,
    'viso-snackbar',
    { closeOnClick: false }
  )
}